export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('en-US').format(price);
};

export const formatWeight = (gram: number | string, dictionary: any) => {
  const g = Number(gram);
  if (!g || g < 1000) return g ? g + ' ' + dictionary.forms.gram : '';

  const kg = Math.floor(g / 1000);
  const rest = g % 1000;

  if (rest === 0) return kg + ' ' + dictionary.forms.kilogram;
  return `${kg} ${dictionary.forms.kilogram} و ${rest} ${dictionary.forms.gram}`;
};

// وزن توی ادمین به گرم ذخیره می‌شه؛ این تابع عددش رو به کیلوگرم با ممیز برمی‌گردونه
// (مثلاً 3300 → "3.3"، 500 → "0.5") تا کنار واحد «کیلوگرم» نمایش داده بشه
export const formatWeightKg = (gram: number | string) => {
  const g = Number(gram);
  if (!g) return '';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 3 }).format(
    g / 1000
  );
};

export const formatQuantityWithSlash = (
  qty: number | string | null | undefined
) => {
  if (qty === null || qty === undefined || qty === '') return '';
  return String(qty).replace('.', '/');
};

const DOT_PLACEHOLDER = '\u0000DOT\u0000';

export const slashifyDots = (text: string | null | undefined) => {
  if (!text) return '';

  return (
    text
      // 1) protect ellipsis: "..." / ".." / "...."
      .replace(/\.{2,}/g, m => m.replace(/\./g, DOT_PLACEHOLDER))

      // 2) protect dots between two ASCII alnum chars
      //    -> www.google.com, e.g., U.S.A., version1.2  ✅
      //    -> سلام.خوبی is NOT protected (Persian letters aren't [A-Za-z0-9])
      .replace(/(?<=[A-Za-z0-9])\.(?=[A-Za-z0-9])/g, DOT_PLACEHOLDER)

      // 3) slashify every remaining dot
      .replace(/\./g, '/')

      // 4) restore
      .replace(new RegExp(DOT_PLACEHOLDER, 'g'), '.')
  );
};
